import { useEffect, useRef } from "react";

type Callback = () => void;

export function useInterval(
  callback: Callback,
  delay: number,
  cancel: boolean = false
) {
  const savedCallback = useRef<Callback>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      if (typeof savedCallback.current === "function") {
        savedCallback.current();
      }
    }

    if (delay !== null && !cancel) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    } else {
      return () => {};
    }
  }, [delay, cancel]);
}
